// MFE Root Component
//    - @author Naroa Gonzalez Sanchez <naroa@hp.com>
//    - @date February 27th 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import React, { useEffect, useState } from 'react';
import Home from '../src/components/Home';
import projectNames from './configs/projectNames';
import resources from '../src/assets/locale';
import { ThemeProvider } from '@veneer/theme';
import { ShellRootProvider } from 'src/contexts/ShellRoot';
import {
  InterfacesType,
  ShellRootComponentProps,
  TranslatorFunctionType
} from '../src/types/shell';

/**
 * @function Root Main function
 * @param props
 * @returns
 */
export default function Root({ useToast, ...props }: ShellRootComponentProps) {
  // You can find all Shell´s props here. See "../src/types/shell" for more details.
  const [t, setT] = useState<TranslatorFunctionType>();
  const { v1, v2 } = window.Shell as InterfacesType;
  const interfaces = {
    v1,
    v2
  };

  // Create a translator function by providing the resource files
  useEffect(() => {
    if (v1.localization) {
      v1.localization
        .createTranslatorFunction(resources)
        .then((v) => setT(() => v));
    }
  }, [v1]);

  // Wait for the translator function creation to show the content
  if (!t) {
    return null;
  }

  // override props value with the one set at the manifest
  props.stack = interfaces.v1.app.getPortalStack();

  // You can find the "stack" information by props
  // const stack = props.stack.
  return (
    <section
      className={`${projectNames.namespace}`}
      id={projectNames.packageJsonName}
    >
      <ThemeProvider
        mode="light"
        shape="round"
      >
        <ShellRootProvider {...{ interfaces, t, useToast }}>
          <Home />
        </ShellRootProvider>
      </ThemeProvider>
    </section>
  );
}
